/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Program
 */
export interface Program {
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof Program
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof Program
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    updatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    programName?: string;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    companyId?: string;
    /**
     * 
     * @type {Date}
     * @memberof Program
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Program
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    productCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof Program
     */
    statusDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Program
     */
    baseProductId?: string;
}

export function ProgramFromJSON(json: any): Program {
    return ProgramFromJSONTyped(json, false);
}

export function ProgramFromJSONTyped(json: any, ignoreDiscriminator: boolean): Program {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
        'updatedAt': !exists(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'updatedBy': !exists(json, 'updated_by') ? undefined : json['updated_by'],
        'programName': !exists(json, 'program_name') ? undefined : json['program_name'],
        'companyId': !exists(json, 'company_id') ? undefined : json['company_id'],
        'startDate': !exists(json, 'start_date') ? undefined : (new Date(json['start_date'])),
        'endDate': !exists(json, 'end_date') ? undefined : (new Date(json['end_date'])),
        'productCategory': !exists(json, 'product_category') ? undefined : json['product_category'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'statusDate': !exists(json, 'status_date') ? undefined : (new Date(json['status_date'])),
        'baseProductId': !exists(json, 'base_product_id') ? undefined : json['base_product_id'],
    };
}

export function ProgramToJSON(value?: Program | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'created_by': value.createdBy,
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'updated_by': value.updatedBy,
        'program_name': value.programName,
        'company_id': value.companyId,
        'start_date': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'end_date': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'product_category': value.productCategory,
        'status': value.status,
        'status_date': value.statusDate === undefined ? undefined : (value.statusDate.toISOString()),
        'base_product_id': value.baseProductId,
    };
}


